<!-- eslint-disable @angular-eslint/template/elements-content -->
<div class="flex flex-col gap-4 text-base">
  <div class="flex flex-col gap-4">
    @if (editorialBoard(); as board) {
      @for (editorGroup of board; track editorGroup) {
        <div class="grid grid-cols-1 gap-2 md:grid-cols-12">
          <strong class="md:col-span-3">{{ editorGroup.title }}</strong>
          <div class="break-words md:col-span-9">
            @for (
              editor of editorGroup.authors
                | orderBy: ['last_name', 'first_name'];
              track editor.id;
              let last = $last
            ) {
              <a
                class="text-primary"
                [dhpPersonLink]="editor"
                [showLink]="showLinks()"
                context="editor"
              ></a>
              <span>{{ !last ? ', ' : '' }}</span>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
